import { useState } from 'react';

const STORAGE_KEY = 'mice.filtersRail.open';
const DESKTOP_QUERY = '(min-width: 1024px)';

/** Aberta em tela larga, recolhida em tela estreita; sem `matchMedia`, aberta. */
function defaultOpen(): boolean {
  try {
    return globalThis.matchMedia(DESKTOP_QUERY).matches;
  } catch {
    return true;
  }
}

function readOpen(): boolean {
  try {
    const stored = globalThis.localStorage.getItem(STORAGE_KEY);
    if (stored === 'true') return true;
    if (stored === 'false') return false;
  } catch {
    // Armazenamento bloqueado (modo privado, política): vale o padrão.
  }
  return defaultOpen();
}

/** Coluna de filtros aberta ou recolhida; a escolha fica neste navegador (só conveniência). */
export function useRailOpen(): { open: boolean; toggle: () => void } {
  const [open, setOpen] = useState(readOpen);
  const toggle = (): void => {
    const next = !open;
    setOpen(next);
    try {
      globalThis.localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      // Armazenamento bloqueado: a escolha vale só para esta página.
    }
  };
  return { open, toggle };
}
